/* eslint-disable react-hooks/rules-of-hooks */
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  forwardRef,
  Fragment,
} from "react";
import styled from "styled-components";

import ReactDOM from "react-dom";
import Button from "./Button";
import { getCalendar } from "utils/date";
import backIcon from "assets/icons/icon_back_black.svg";

const setting = {
  label: {
    title: "yyyy년 sm월",
    year: "년",
    month: "월",
  },
  week: {
    first: 0,
    name: ["일", "월", "화", "수", "목", "금", "토"],
    color: ["red", "", "", "", "", "", "blue"],
  },
  date: {
    min: "1900-01-01",
    max: "2040-12-31",
  },
  holiday: [
    { name: "새해", date: [0, 1, 1] },
    { name: "설날", date: [-1, 12, 31], isLunar: true },
    { name: "설날", date: [0, 1, 1], isLunar: true },
    { name: "설날", date: [0, 1, 2], isLunar: true },
    { name: "삼일절", date: [0, 3, 1] },
    { name: "부처님 오신 날", date: [0, 4, 8], isLunar: true },
    { name: "어린이날", date: [0, 5, 5] },
    { name: "현충일", date: [0, 6, 6] },
    { name: "광복절", date: [0, 8, 15] },
    { name: "추석", date: [0, 8, 14], isLunar: true },
    { name: "추석", date: [0, 8, 15], isLunar: true },
    { name: "추석", date: [0, 8, 16], isLunar: true },
    { name: "개천절", date: [0, 10, 3] },
    { name: "한글날", date: [0, 10, 9] },
    { name: "성탄절", date: [0, 12, 25] },
    { name: "21대 국회의원 선거", date: [2020, 4, 15] },
    { name: "임시공휴일", date: [2020, 8, 17] },
    { name: "20대 대통령 선거", date: [2022, 3, 9] },
    { name: "2022년 지방선거", date: [2022, 6, 1] },
  ],
};

// 한번 계산했던 내용은 캐쉬 데이터에 저장한다.
const holidayInfo = {};

export const Calendar = (props) => {
  const today = getCalendar(null, "yyyy-mm-01");

  const [date, setDate] = useState(props.date || props.value || today);
  const [value, setValue] = useState(props.value);

  if (props.import) {
    if (props.date && props.date != date) {
      setDate(props.date);
    }
    if (props.value && props.value != value) {
      setValue(props.value);
    }
  } else {
    useEffect(() => {
      setDate(props.date || props.value || today);
      setValue(props.value);
      return () => {};
    }, [props.visible]);
  }

  const eventHandler = {
    changeSelector: (event) => {
      const changeValue = Number(event.currentTarget.value);
      const newDate = new Date(date);
      if (event.currentTarget.name == "year") {
        newDate.setFullYear(changeValue);
      } else {
        newDate.setMonth(changeValue - 1);
      }
      setDate(getCalendar(newDate));
    },
    setMonth: (value) => {
      const oldDate = new Date(date);
      oldDate.setMonth(oldDate.getMonth() + value);
      const newDate = getCalendar(oldDate);
      setDate(newDate);
    },
    setDate: (event) => {
      const target = event.currentTarget;
      const newDate = target.getAttribute("data-date");
      const isNone = target.parentNode.classList.contains("none");
      if (isNone) {
        setDate(newDate);
      } else {
        const newValue = value == newDate ? "" : newDate;
        setValue(newValue);
        if (props.import) {
          if (props.onChange) props.onChange(newValue);
        }
      }
    },
    submit: () => {
      if (props.onChange) props.onChange(value);
    },
  };

  const render = () => {
    const isSelect = false;
    const mode = props.mode || "daily";

    const getTitle = () => {
      const getYearList = () => {
        const maxDate = props.max
          ? new Date(props.max)
          : new Date(new Date().getFullYear() + 1, 11, 31);
        const maxYear = maxDate.getFullYear();
        const minDate = props.min
          ? new Date(props.min)
          : new Date(new Date().getFullYear() - 1, 0, 1);
        const minYear = minDate.getFullYear();
        const option = [];
        for (let i = maxYear; i >= minYear; i--)
          option.push(
            <option key={i} value={i}>
              {i + yearLabel}
            </option>
          );
        return option;
      };
      const getMonthList = () => {
        const option = [];
        for (let i = 1; i < 13; i++)
          option.push(
            <option key={i} value={i}>
              {i.zf(2) + monthLabel}
            </option>
          );
        return option;
      };

      const year = new Date(date).getFullYear();
      const yearLabel = setting.label.year;

      const month = new Date(date).getMonth();
      const monthLabel = setting.label.month;

      return isSelect ? (
        <div>
          <select
            className="ui-select"
            name="year"
            value={year}
            onChange={eventHandler.changeSelector}
          >
            <option value="">{yearLabel}</option>
            {getYearList()}
          </select>
          <select
            className="ui-select"
            name="month"
            value={month + 1}
            onChange={eventHandler.changeSelector}
          >
            <option value="">{monthLabel}</option>
            {getMonthList()}
          </select>
        </div>
      ) : (
        new Date(date).format(setting.label.title)
      );
    };
    const getHead = () => {
      const nameList = getWeekNameList();
      const td = nameList.map((item, index) => {
        return <td key={index}>{item}</td>;
      });
      return <tr>{td}</tr>;
    };
    const getBody = () => {
      const weekList = getWeekList(date, true);
      const tbody = [];
      weekList.forEach((item, index) => {
        const tr = [];
        let focusWeek = false;
        item.forEach((item, index) => {
          const nameList = [];
          if (item.isNone) {
            nameList.push("none");
          } else {
            if (item.isToday) nameList.push("today");
            if (item.isHoliday) nameList.push("holiday");
            if (item.date == value) {
              if (mode == "daily") nameList.push("selected");
              focusWeek = true;
            }
          }
          tr.push(
            <td key={index} className={nameList.join(" ")}>
              <a
                data-date={item.date}
                onClick={eventHandler.setDate}
                title={item.holidayName}
              >
                <span className="date">{item.day}</span>
                {props.onRender ? props.onRender(item) : null}
              </a>
            </td>
          );
        });
        const className = mode == "weekly" && focusWeek ? "focus" : null;
        tbody.push(
          <tr key={index} className={className}>
            {tr}
          </tr>
        );
      });
      return tbody;
    };

    return props.import ? (
      <Wrapper>
        <div className="middle">
          <table>
            <tbody>{getBody()}</tbody>
          </table>
        </div>
      </Wrapper>
    ) : (
      <Wrapper>
        <div className="top">
          <h4>
            <button
              className="prev"
              onClick={() => {
                eventHandler.setMonth(-1);
              }}
            ></button>
            {getTitle()}
            <button
              className="next"
              onClick={() => {
                eventHandler.setMonth(1);
              }}
            ></button>
          </h4>
        </div>
        <div className="middle">
          <table>
            <thead>{getHead()}</thead>
            <tbody>{getBody()}</tbody>
          </table>
        </div>
        <div className="bottom">
          <Button color="blue" onClick={eventHandler.submit}>
            Submit
          </Button>
        </div>
      </Wrapper>
    );
  };

  return render();
};

const Wrapper = styled.div`
  .top {
    margin-bottom: 25px;
  }
  .top h4 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.35rem;
    font-weight: bold;
  }
  .top h4 select {
    vertical-align: top;
    height: 25px;
    min-height: auto;
    line-height: 25px;
    border: none !important;
    font-weight: inherit;
  }
  .top h4 select[name="year"] {
    width: auto;
  }
  .top h4 select[name="month"] {
    margin-left: 0;
    width: auto;
  }

  .top h4 button {
    width: 25px;
    height: 25px;
    background: white url(${backIcon}) no-repeat center center / 40%;
    border: none;
    opacity: 0.85;
  }
  .top h4 button.prev {
    margin-left: 5px;
  }
  .top h4 button.next {
    margin-right: 5px;
    transform: rotate(180deg);
  }

  .middle {
    margin: 1px;
  }
  .middle table {
    width: 100%;
    background-color: white;
    line-height: 1.2;
    text-align: center;
  }
  .middle table td {
    position: relative;
    padding: 2px;
    border: none;
  }
  .middle table td a {
    position: relative;
    display: inline-flex;
    width: 2.625em;
    height: 2.625em;
    border-radius: 100%;
    flex-flow: wrap;
    align-items: center;
    justify-content: center;
    color: inherit;
    transition: background-color 0.1s;
  }
  /*
	.middle table td a:hover				{background-color:var(--lightGray); text-decoration:none}
	*/
  .middle table tr.focus td:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: var(--lightBlue);
  }
  .middle table tr.focus td:first-child:before {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .middle table tr.focus td:last-child:before {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .middle table td a .date {
    width: 100%;
  }
  .middle table td a .date + .info {
    font-size: 0.75rem;
    color: var(--gray);
  }

  .middle table td:nth-child(1) {
    color: #fa7575;
  }
  .middle table td:nth-child(7) {
    color: #6d88e9;
  }

  .middle table td.today a .date {
    color: var(--blue);
  }
  .middle table td.selected a {
    background-color: var(--blue);
    color: var(--white);
    z-index: 2;
  }
  .middle table td.selected a .date {
    color: white;
  }
  .middle table td.holiday {
    color: #fa7575;
  }
  .middle table td.none {
    color: var(--border);
  }

  .bottom {
    margin-top: 8px;
  }
`;

// 달력의 주일 정보를 가져온다.
export const getWeekNameList = () => {
  const firstWeek = setting.week.first;
  let nameList = setting.week.name.slice();
  const prefix = nameList.splice(firstWeek);
  nameList = prefix.concat(nameList);
  return nameList;
};

export const getDayList = (date) => {
  const today = getCalendar();

  date = new Date(date);
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();

  const endDay = new Date(year, month + 1, 0).getDate();
  const dayList = [];

  for (let i = 0; i < 7; i++) {
    if (day > endDay) {
      day = 1;
      month++;
      if (month == 12) {
        year++;
        month = 0;
      }
    }
    const date = getCalendar(new Date(year, month, day));
    const holidayName = getHolidayName(year, month + 1, day);
    dayList.push({
      date: date,
      year: year,
      month: month + 1,
      day: day,
      holidayName: holidayName,
      isHoliday: holidayName,
      isToday: date == today,
    });
    day++;
  }
  return dayList;
};

// 주단위로 해당 달의 정보를 가져온다.
export const getWeekList = (date, isFix) => {
  const today = getCalendar();
  const thisDate = new Date(date || today);
  let year = thisDate.getFullYear();
  let month = thisDate.getMonth();
  let day = thisDate.getDate();

  let thisMonthStart = new Date(year, month, 1).getDay();
  const thisMonthEnd = new Date(year, month + 1, 0).getDate();
  const lastMonth = new Date(year, month, 0).getMonth();
  const lastMonthEnd = new Date(year, month, 0).getDate();
  const lastMonthStart = lastMonthEnd - thisMonthStart + 1 + setting.week.first;

  day = lastMonthStart;
  month--;
  if (lastMonth == 11) {
    year--;
    month = 11;
  }

  const weekList = [];
  const weekLength = isFix ? 6 : Math.ceil((thisMonthStart + thisMonthEnd) / 7);

  let isNone = true;
  for (let i = 0; i < weekLength; i++) {
    const dayList = [];
    for (let j = 0; j < 7; j++) {
      if ((i == 0 && day > lastMonthEnd) || (i > 0 && day > thisMonthEnd)) {
        day = 1;
        month++;
        if (month == 12) {
          year++;
          month = 0;
        }
        isNone = i == 0 ? false : true;
      }
      const date = getCalendar(new Date(year, month, day));
      const holidayName = getHolidayName(year, month + 1, day);
      dayList.push({
        date: date,
        year: year,
        month: month + 1,
        day: day,
        holidayName: holidayName,
        isHoliday: holidayName,
        isToday: date == today,
        isNone: isNone,
      });
      day++;
    }
    weekList.push(dayList);
  }
  return weekList;
};

// 음력 날짜를 양력 날짜로 변환한다.
const convertLunarToSolar = (year, month, day) => {
  const table = [
    [1, 2, 4, 1, 1, 2, 1, 2, 1, 2, 2, 1], // 1841
    [2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 1],
    [2, 2, 2, 1, 2, 1, 4, 1, 2, 1, 2, 1],
    [2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 5, 2, 1, 2, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
    [2, 1, 2, 3, 2, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 1, 2, 3, 2, 1, 2, 2], // 1851
    [2, 1, 2, 2, 1, 1, 2, 1, 2, 1, 1, 2],
    [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 5, 2, 1, 2, 1, 2],
    [1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
    [1, 2, 1, 1, 5, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
    [2, 1, 6, 1, 1, 2, 1, 1, 2, 1, 2, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2], // 1861
    [2, 1, 2, 1, 2, 2, 1, 5, 2, 1, 1, 2],
    [1, 2, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
    [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 4, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],
    [1, 2, 2, 3, 2, 1, 1, 2, 1, 2, 2, 1],
    [2, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 2, 2, 1, 2, 1, 2, 1, 1, 5, 2, 1],
    [2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1, 2], // 1871
    [1, 2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2],
    [1, 1, 2, 1, 2, 4, 2, 1, 2, 2, 1, 2],
    [1, 1, 2, 1, 2, 1, 2, 1, 2, 2, 2, 1],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1],
    [2, 2, 1, 1, 5, 1, 2, 1, 2, 2, 1, 2],
    [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 2, 4, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 1, 2, 2, 1, 2, 2, 1, 2, 1, 1, 2],
    [1, 2, 1, 2, 1, 2, 5, 2, 2, 1, 2, 1], // 1881
    [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2],
    [2, 1, 1, 2, 3, 2, 1, 2, 2, 1, 2, 2],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 2, 1, 5, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 5, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2], // 1891
    [1, 1, 2, 1, 1, 5, 2, 2, 1, 2, 2, 2],
    [1, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 5, 1, 2, 1, 2, 1, 2, 1],
    [2, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],
    [2, 1, 5, 2, 2, 1, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 5, 2, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1], // 1901
    [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1],
    [2, 2, 1, 2, 2, 1, 1, 2, 1, 2, 1, 2],
    [1, 2, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 1, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2],
    [1, 5, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
    [2, 1, 2, 1, 1, 5, 1, 2, 2, 1, 2, 2], // 1911
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
    [2, 2, 1, 2, 5, 1, 2, 1, 2, 1, 1, 2],
    [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 3, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 2, 1, 1, 2, 1, 5, 2, 1, 2, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2], // 1921
    [2, 1, 2, 2, 3, 2, 1, 1, 2, 1, 2, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
    [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1],
    [2, 1, 2, 5, 2, 1, 2, 2, 1, 2, 1, 2],
    [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 5, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],
    [1, 2, 2, 1, 1, 5, 1, 2, 1, 2, 2, 1],
    [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1], // 1931
    [2, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
    [1, 2, 2, 1, 6, 1, 2, 1, 2, 1, 1, 2],
    [1, 2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2],
    [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 4, 1, 1, 2, 2, 1, 2, 2, 2, 1],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1],
    [2, 2, 1, 1, 2, 1, 4, 1, 2, 2, 1, 2],
    [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 2, 1, 2, 2, 4, 1, 1, 2, 1, 2, 1], // 1941
    [2, 1, 2, 2, 1, 2, 2, 1, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 4, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2],
    [2, 5, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 1, 2, 2, 1, 2, 3, 2, 1, 2, 1, 2],
    [1, 2, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2], // 1951
    [1, 2, 1, 2, 4, 1, 2, 2, 1, 2, 1, 2],
    [1, 2, 1, 1, 2, 2, 1, 2, 2, 1, 2, 2],
    [1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2],
    [2, 1, 4, 1, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 2, 1, 1, 5, 2, 1, 2, 2],
    [1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 2, 5, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2], // 1961
    [1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 2, 3, 2, 1, 2, 1, 2, 2, 2, 1],
    [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 2],
    [1, 2, 5, 2, 1, 1, 2, 1, 1, 2, 2, 1],
    [2, 2, 1, 2, 2, 1, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 2, 1, 5, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],
    [1, 2, 1, 1, 5, 2, 1, 2, 2, 2, 1, 2], // 1971
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 5, 1, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
    [2, 2, 1, 2, 1, 2, 1, 5, 1, 2, 1, 2],
    [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 1],
    [2, 1, 2, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 6, 1, 2, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2], // 1981
    [2, 1, 2, 3, 2, 1, 1, 2, 1, 2, 2, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
    [2, 1, 2, 2, 1, 1, 2, 1, 1, 5, 2, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1],
    [2, 1, 2, 1, 2, 5, 2, 2, 1, 2, 1, 2],
    [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 1, 5, 1, 2, 2, 1, 2, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2], // 1991
    [1, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
    [1, 2, 5, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 1, 2, 5, 2, 1, 1, 2],
    [1, 2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 1],
    [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 3, 2, 2, 1, 2, 2, 2, 1],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1],
    [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1],
    [2, 2, 1, 5, 2, 1, 1, 2, 1, 2, 1, 2], // 2001
    [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2],
    [1, 5, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 2, 1, 5, 2, 2, 1, 2, 2],
    [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2],
    [2, 2, 1, 1, 5, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1], // 2011
    [2, 1, 2, 5, 2, 2, 1, 1, 2, 1, 2, 1],
    [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2, 1],
    [2, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 2, 1, 2, 1, 4, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2],
    [2, 1, 2, 5, 2, 1, 1, 2, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1], // 2021
    [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
    [1, 5, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 2, 1, 1, 5, 2, 1, 2, 2, 2, 1],
    [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1],
    [2, 2, 2, 1, 5, 1, 2, 1, 1, 2, 2, 1],
    [2, 2, 1, 2, 2, 1, 1, 2, 1, 1, 2, 2],
    [1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
    [2, 1, 5, 2, 1, 2, 2, 1, 2, 1, 2, 1], // 2031
    [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 5, 2],
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 4, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
    [2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1],
    [2, 2, 1, 2, 5, 2, 1, 2, 1, 2, 1, 1],
    [2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2], // 2041
    [1, 5, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],
    [2, 1, 2, 1, 1, 2, 3, 2, 1, 2, 2, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
    [2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
    [2, 1, 2, 2, 4, 1, 2, 1, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 2, 1, 2, 1, 1, 2, 1],
    [2, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1],
    [1, 2, 4, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2], // 2051
    [1, 2, 1, 1, 2, 1, 1, 5, 2, 2, 2, 2],
    [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],
    [1, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
    [1, 2, 2, 1, 2, 4, 1, 1, 2, 1, 2, 1],
    [2, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
    [1, 2, 2, 1, 2, 1, 2, 2, 1, 1, 2, 1],
    [2, 1, 2, 4, 2, 1, 2, 1, 2, 2, 1, 1],
    [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 1],
    [2, 2, 3, 2, 1, 1, 2, 1, 2, 2, 2, 1], // 2061
    [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1],
    [2, 2, 1, 2, 1, 2, 3, 2, 1, 2, 1, 2],
    [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2],
    [1, 2, 1, 2, 5, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 1, 2, 2, 1, 2, 2, 1, 2],
    [1, 2, 1, 5, 1, 2, 1, 2, 2, 2, 1, 2],
    [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2],
    [2, 1, 2, 1, 2, 1, 1, 5, 2, 1, 2, 2], // 2071
    [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
    [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
    [2, 1, 2, 2, 1, 5, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1],
    [2, 1, 2, 3, 2, 1, 2, 2, 2, 1, 2, 1],
    [2, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2],
    [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [2, 1, 5, 2, 1, 1, 2, 1, 2, 1, 2, 2],
    [1, 2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2], // 2081
    [1, 2, 2, 2, 1, 2, 3, 2, 1, 1, 2, 2],
    [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],
    [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
    [1, 2, 1, 1, 6, 1, 2, 2, 1, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1],
    [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
    [1, 2, 1, 5, 1, 2, 1, 1, 2, 2, 2, 1],
    [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1],
    [2, 2, 2, 1, 2, 1, 1, 5, 1, 2, 2, 1],
    [2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1], // 2091
    [2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
    [1, 2, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1],
    [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],
    [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
    [2, 1, 2, 3, 2, 1, 1, 2, 2, 2, 1, 2],
    [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
    [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
    [2, 5, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2],
    [2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1],
    [2, 2, 1, 2, 2, 1, 5, 2, 1, 1, 2, 1],
  ];
  const solMonthDay = new Array(31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
  const isLeapYear = function (year) {
    return year % 400 == 0 || (year % 100 != 0 && year % 4 == 0);
  };
  solMonthDay[1] = isLeapYear(year) ? 29 : 28;
  const lunaMonthDay = function (value) {
    switch (value) {
      case 1:
        return 29;
      case 2:
        return 30;
      case 3:
        return 29 + 29;
      case 4:
        return 29 + 30;
      case 5:
        return 30 + 29;
      case 6:
        return 30 + 30;
    }
  };

  let lunaYear, lunaMonth, lunaDay, yd, td;

  // 해당 년도의 음력 마지막 날짜
  if (month == 12 && day == 31) day = lunaMonthDay(table[year - 1841][11]);

  // 1841년부터 현재까지 음력 날짜 수 (음력 1840년 1월 1일은 양력 1841년 1월 23일)
  td = 0;
  for (let i = 0; i < year - 1841; i++)
    for (let j = 0; j < 12; j++) td += lunaMonthDay(table[i][j]);
  for (let j = 0; j < month - 1; j++) td += lunaMonthDay(table[year - 1841][j]);
  td = td + day + 22;

  lunaYear = 1840;
  do {
    lunaYear = lunaYear + 1;
    yd = isLeapYear(lunaYear) ? 366 : 365;
    if (td <= yd) break;
    td = td - yd;
  } while (1);

  lunaMonth = 0;
  do {
    lunaMonth = lunaMonth + 1;
    if (td <= solMonthDay[lunaMonth - 1]) break;
    td = td - solMonthDay[lunaMonth - 1];
  } while (1);

  lunaDay = td;

  const date = new Date(lunaYear, lunaMonth - 1, lunaDay);
  lunaYear = date.getFullYear();
  lunaMonth = date.getMonth() + 1;
  lunaDay = date.getDate();
  return { year: lunaYear, month: lunaMonth, day: lunaDay };
};

// 조회 날짜가 휴일인 경우 휴일명을 리턴한다.
const getHolidayName = (year, month, day) => {
  // 조회 년도가 캐쉬되었는지 먼저 확인한다.
  if (!holidayInfo[year]) {
    // 양력과 음력 휴일 데이터를 변환한다.
    const getHolidayList = () => {
      return (setting.holiday || [])
        .filter((item) => {
          return item.date[0] && item.date[0] > 0 ? item.date[0] == year : true;
        })
        .map((item) => {
          let date = {
            year: item.date[0] && item.date[0] < 0 ? year - 1 : year,
            month: item.date[1],
            day: item.date[2],
          };
          if (item.isLunar)
            date = convertLunarToSolar(date.year, date.month, date.day);
          return {
            name: item.name,
            year: date.year,
            month: date.month,
            day: date.day,
          };
        });
    };

    // 대체 공휴일을 셋팅한다.
    const setSubHolidayList = () => {
      const subHolidayList = [];

      // 대체 공휴일 목록을 만든다.
      for (let i = 0; i < holidayList.length; i++) {
        const itemA = holidayList[i];
        const itemB = holidayList[i + 1];
        const name = holidayList[i].name;

        // 제외되는 대체 공휴일을 제외하고 대체 공휴일을 목록에 추가한다.
        const exceptSubHolidayList = [
          "새해",
          "설날",
          "부처님 오신 날",
          "현충일",
          "성탄절",
        ];

        if (exceptSubHolidayList.indexOf(name) == -1) {
          // 만약 대체 공휴일이 서로 겹치는 경우 하나만 적용되게 합친다.
          if (itemA && itemB) {
            const timeA = new Date(
              itemA.year,
              itemA.month - 1,
              itemA.day
            ).getTime();
            const timeB = new Date(
              itemB.year,
              itemB.month - 1,
              itemB.day
            ).getTime();
            if (timeA == timeB) {
              itemA.name = itemA.name + ", " + itemB.name;
              i++;
            }
          }
          subHolidayList.push(itemA);
        }
      }

      const checkHoliday = (name, date, option) => {
        return holidayList.some((item) => {
          if (
            date.getTime() ==
            new Date(item.year, item.month - 1, item.day).getTime()
          ) {
            if (option) {
              return item.name == name;
            } else {
              return item.name != name;
            }
          }
        });
      };

      // 대체 공휴일을 계산해 공휴일 목록에 추가한다.
      subHolidayList.forEach((item) => {
        let date = new Date(item.year, item.month - 1, item.day);
        const name = item.name;
        const weekIndex = date.getDay();
        const isHoliday = checkHoliday(name, date);

        // 토, 일, 다른 휴일과 겹치는 경우
        if (
          weekIndex == 0 ||
          (weekIndex == 6 && name != "설날" && name != "추석") ||
          isHoliday
        ) {
          for (let i = 0; i < 10; i++) {
            date.setDate(date.getDate() + 1);
            const weekIndex = date.getDay();
            const isHoliday = checkHoliday(name, date, false);
            const isContinueHoliday = checkHoliday(name, date, true);
            if (
              weekIndex != 0 &&
              weekIndex != 6 &&
              !isContinueHoliday &&
              !isHoliday
            ) {
              const newName = "대체 공휴일(" + name + ")";
              if (
                !holidayList.some((item) => {
                  return item.name == newName;
                })
              ) {
                holidayList.push({
                  name: newName,
                  year: date.getFullYear(),
                  month: date.getMonth() + 1,
                  day: date.getDate(),
                });
              }
              break;
            }
          }
        }
      });
    };

    // 해당 년도의 휴일 정보를 추가한다.
    const setHolidayInfo = () => {
      holidayList.forEach((item) => {
        if (!holidayInfo[item.year]) holidayInfo[item.year] = {};
        if (!holidayInfo[item.year][item.month])
          holidayInfo[item.year][item.month] = {};
        holidayInfo[item.year][item.month][item.day] = item.name;
      });
    };

    const holidayList = getHolidayList();
    setSubHolidayList();
    setHolidayInfo();
  }
  return holidayInfo[year][month] ? holidayInfo[year][month][day] || "" : "";
};

export default Calendar;
